import {config} from "..";
import {getutctime} from "../api";
import md5 from "./md5";
let diffTime;
/**
 * 唯一识别码
 */
export function getUUID() {
	var uuid = window.localStorage.getItem("_g_uuid");
	if (!uuid) {
		let s = [];
		let hexDigits = "0123456789abcdef";
		for (let i = 0; i < 36; i++) {
			s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
		}
		s[14] = "4";
		s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);
		s[8] = s[13] = s[18] = s[23] = "";
		uuid = s.join("");
		window.localStorage.setItem("_g_uuid", uuid);
	}
	return uuid;
}

/**
 * 获取唯一识别码
 * @returns {*}
 */
export function getRandomGuid() {
	function a() {
		return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
	}

	return a() + a() + a() + a() + a() + a() + a() + a();
}

export function sleep(ms) {
	return new Promise(function (resolve, reject) {
		setTimeout(resolve, ms);
	});
}

/**
 * 获取校验后的当前时间(秒)
 * @returns {Promise<number>}
 */
export async function getTimestamp() {
	if (diffTime == null) diffTime = (await getutctime()) - Math.round(Date.now() / 1000);
	return Math.round(Date.now() / 1000) + diffTime;
}
/**
 * 获取当前时间戳
 * @returns
 */
export function getNowTimestamp() {
	return Math.round(new Date().getTime() / 1000);
}

/**
 * 获取签名字符串
 * @param {any} obj
 * @returns {string}
 */
function getDataSignString(obj) {
	let sign = "";
	let keys = Object.keys(obj).sort();
	// console.log("keys", keys);
	for (let k of keys) {
		let v = obj[k];
		if (typeof v == "string") v = v.trim();
		if (v === "") continue;
		if (sign === "") {
			sign = k + "=" + v;
		} else {
			sign = sign + "&" + k + "=" + v;
		}
	}
	sign += "hUuPd20171206LuOnD";
	return sign;
}

/**
 * 计算签名
 * @param {any} data
 * @returns {string}
 */
export function getDataSign(data) {
	// console.log("getdatasign", data);
	return md5(getDataSignString(data)).toLowerCase();
}

/**
 * 添加公共参数
 * @param {any} data
 */
export async function signData(data) {
	if (typeof data == "string") return;
	if (data) {
		if (data.deviceid == null && !data.machineid) data.deviceid = getUUID();
		if (data.timestamp == null) data.timestamp = await getTimestamp();
		if (data.productinfo == null && !data.machineid && !data.paymethod)
			data.productinfo = config.productInfo;
		if (data.datasign == null) data.datasign = getDataSign(data);
	}
}
